import { render, staticRenderFns } from "./UiConfirm.vue?vue&type=template&id=20d96e9c&lang=pug"
import script from "./UiConfirm.vue?vue&type=script&lang=js"
export * from "./UiConfirm.vue?vue&type=script&lang=js"
import style0 from "./UiConfirm.vue?vue&type=style&index=0&id=20d96e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports